// src/components/sections/HeroTransform.js
import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

/*
  Hero visual: the transformation this product performs.
  Left  = a document (as it arrives)
  Right = structured data with importance labels (what you get)

  The meaning reads from the *shape* alone — dense paper turning into
  tidy labeled rows — so it works even when the text is too small to read.
*/

const ROWS = [
  { key: '請求先', value: '株式会社ABC商事', imp: 'core' },
  { key: '請求書番号', value: 'INV-2024-0342', imp: 'admin' },
  { key: '発行日', value: '2024年9月5日', imp: 'admin' },
  { key: '合計金額', value: '¥330,000', imp: 'core' },
];

const IMP_LABEL = { core: 'コア', admin: '管理用', aux: '補助用' };

const HeroTransform = () => {
  const { text, isEnglish } = useLanguage();
  const fieldEn = { '請求先': 'Bill to', '請求書番号': 'Invoice no.', '発行日': 'Issue date', '合計金額': 'Total' };
  const valueEn = { '株式会社ABC商事': 'ABC Trading Co.', '2024年9月5日': 'Sep 5, 2024' };
  const importanceEn = { core: 'Core', admin: 'Admin', aux: 'Auxiliary' };
  return (
  <div className="hero-transform">
    {/* ---------- BEFORE: the document ---------- */}
    <div className="ht-side">
      <span className="ht-caption">{text('書類', 'Document')}</span>

      <div className="ht-doc">
        <div className="ht-doc-title">{text('請求書', 'Invoice')}</div>
        <span className="ht-doc-rule" />

        <div className="ht-doc-meta">
          <span style={{ width: '52%' }} />
          <span style={{ width: '38%' }} />
        </div>

        <div className="ht-doc-amount" />

        <div className="ht-doc-table">
          <span /><span /><span />
          <span /><span /><span />
          <span /><span /><span />
        </div>

        <div className="ht-doc-foot">
          <span style={{ width: '30%' }} />
          <span style={{ width: '44%' }} />
        </div>
      </div>
    </div>

    {/* ---------- the transformation ---------- */}
    <div className="ht-arrow" aria-hidden="true">
      <span className="ht-arrow-line" />
      <span className="ht-arrow-head" />
      <span className="ht-arrow-badge">AI</span>
    </div>

    {/* ---------- AFTER: structured data ---------- */}
    <div className="ht-side ht-side--data">
      <span className="ht-caption">{text('構造化データ', 'Structured data')}</span>

      <div className="ht-data">
        <div className="ht-data-head">
          <span>{text('項目名', 'Field')}</span>
          <span>{text('値', 'Value')}</span>
          <span>{text('重要度', 'Importance')}</span>
        </div>

        {ROWS.map((r, i) => (
          <div className="ht-data-row" key={r.key} style={{ '--i': i }}>
            <span className="ht-data-key">{isEnglish ? fieldEn[r.key] || r.key : r.key}</span>
            <span className="ht-data-val">{isEnglish ? valueEn[r.value] || r.value : r.value}</span>
            <span className={`ht-badge ht-badge--${r.imp}`}>
              {isEnglish ? importanceEn[r.imp] : IMP_LABEL[r.imp]}
            </span>
          </div>
        ))}
      </div>

      {/* what you walk away with */}
      <div className="ht-export">
        <span className="ht-export-chip">
          <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
            <path
              d="M8 1v8m0 0L4.5 5.5M8 9l3.5-3.5M2 11.5v1A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5v-1"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {text('CSVダウンロード', 'Download CSV')}
        </span>
        <span className="ht-export-note">{text('Excelでそのまま開けます', 'Opens directly in Excel')}</span>
      </div>
    </div>
  </div>
  );
};

export default HeroTransform;
